import LogType from "@/models/api/logType/LogType";
import axios, { AxiosResponse } from "axios";

class Service {
    public async GetLogTypes(): Promise<AxiosResponse<LogType[]>> {
        return axios.get('api/logType/');
    }
    public async GetLogType(id: number): Promise<AxiosResponse<LogType>> {
        return axios.get(`api/logType/${id}`);
    }
    public async SaveLogType(data: LogType): Promise<AxiosResponse<any>> {
        return axios.post("api/logType/", data);
    }
}

export const LogTypeService: Service = new Service();
